<h3 mat-dialog-title>Add New Domain</h3>
<form [formGroup]="addDomainForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>Domain</mat-label>
      <input matInput formControlName="domain">
      @if (addDomainForm.get('domain')?.errors?.['required']) {
        <mat-error>Domain is required.</mat-error>
      }
      @if (addDomainForm.get('domain')?.errors?.['pattern']) {
        <mat-error>Domain must be a valid URL.</mat-error>
      }
      @if (addDomainForm.get('domain')?.errors?.['blockedDomain']) {
        <mat-error>This domain is not allowed.</mat-error>
      }
    </mat-form-field>
    
    @if (errorMessage) {
      <div class="error-message">{{errorMessage}}</div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button  type="button" [disabled]="isSubmitting" (click)="onCancel()">Cancel</button>
    <button mat-flat-button 
            color="primary" s
            type="submit" 
            [disabled]="!addDomainForm.valid || isSubmitting">
      @if (loadingService.loading$ | async) {
        <app-loading-spinner [diameter]="20" [strokeWidth]="2"></app-loading-spinner>
      } @else {
        Add
      }
    </button>
  </mat-dialog-actions>
</form>